import { render } from "./MailTemplateCategoriesView.vue?vue&type=template&id=68cfd805&scoped=true"
import script from "./MailTemplateCategoriesView.vue?vue&type=script&lang=js"
export * from "./MailTemplateCategoriesView.vue?vue&type=script&lang=js"

import "./MailTemplateCategoriesView.vue?vue&type=style&index=0&id=68cfd805&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68cfd805"]])

export default __exports__